import { Col, Card, CardBody } from "reactstrap";
import { Progressbar } from "../../../../AbstractElements";
import { ProgressWithNumberSteps } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PROGRESS_NUMBER_DATA } from "../../../../Data/UiKit/Progress/index";
import { DynamicProgressWithNumberSteps } from "./DynamicProgressWithNumberSteps";

export const ProgressWithNumberStepsCart = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={ProgressWithNumberSteps} span={PROGRESS_NUMBER_DATA} />
        <CardBody>
          <div className="position-relative m-4">
            <Progressbar value="50" className="progress-wrapper" />
            <button className="position-absolute top-0 start-0 btn-sm btn-primary translate-middle rounded-circle" type="button" style={{width: "2rem",height: "2rem",}}>1</button>
            <DynamicProgressWithNumberSteps/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
